export const ALLOW_EXPERIENCE_DETAILS_PREFETCH = false;
export const ALLOW_FOOD_MENU_PREFETCH = false;
export const ALLOW_NAVBAR_ITEMS_PREFETCH = false;
export const ALLOW_FOOTER_LINKS_PREFETCH = false;
export const ALLOW_SLIDER_ITEMS_PREFETCH = false;
export const ALLOW_MOVIE_OFFER_CARD_PREFETCH = false;
export const ALLOW_OFFER_DETAILS_PREFETCH = false;
export const ALLOW_CINEMA_DETAILS_PREFETCH = false;
export const ALLOW_MOVIE_DETAILS_PREFETCH = true;
export const ALLOW_SIDE_MENU_ITEMS_PREFETCH = false;
